import type { RequestResponse } from '@/types/publicType'
import type { emojiApiInterface } from '~/types/apiType/emojiType'

/**
 * 获取
 */
export function apiGetEmoji(): Promise<RequestResponse<emojiApiInterface>> {
  return getFetchData({
    url: '/client/init',
    method: 'GET'
  })
}
